import { NormalSizes, NormalTypes } from "../../../utils/prop-types";

export type InputSize = {
  height: string;
  fontSize: string;
  iconClasses: string;
};

export const getSizes = (size?: NormalSizes) => {
  const sizes: { [key in NormalSizes]: InputSize } = {
    mini: {
      height: "h-7",
      fontSize: "text-xs",
      iconClasses: "w-4 px-2",
    },
    small: {
      height: "h-8",
      fontSize: "text-xs",
      iconClasses: "w-4 px-2",
    },
    medium: {
      height: "h-9",
      fontSize: "text-sm",
      iconClasses: "w-4 px-2",
    },
    large: {
      height: "h-11",
      fontSize: "text-base",
      iconClasses: "w-5 px-3",
    },
  };
  if (!size) return sizes.medium;
  return sizes[size];
};

export const getColors = (status?: NormalTypes): string => {
  const colors: { [key in NormalTypes]: string } = {
    default:
      "text-foreground border-gray-200 bg-white hover:border-gray-700 focus-within:border-gray-700",
    secondary:
      "text-foreground border-accent bg-white hover:border-accent focus-within:border-accent",
    success:
      "text-foregorund border-primary-light bg-white hover:border-primary focus-within:border-primary",
    warning:
      "text-foreground border-yellow-200 bg-white hover:border-yellow-500 focus-within:border-yellow-500",
    error:
      "text-error border-red-500 bg-white hover:border-red-700 focus-within:border-red-700",
  };

  if (!status) return colors.default;
  return colors[status];
};
